export const manifest = {
  screens: {
    scr_norjm6: { name: "Home", route: "/" },
  },
}
